// extracted by mini-css-extract-plugin
export default {"signupMainDiv":"Login_signupMainDiv__6YIIe","container":"Login_container__J0VJW","alreadyAccText":"Login_alreadyAccText__QdGs+","siteLogo":"Login_siteLogo__eVF9v"};